import { Link } from '@/components/ui'
import type { ColumnDef } from '@/components/ui/table/types'
import type { Filing } from '@/modules/tools/bankruptcy'
import { currencyFromCents, formatDate, getFilingPath } from '@/utils'
import { CaseStatusCell } from './CaseStatusCell'

// Data arrives ranked by distribution from lukita, so the default order is the headline sort.
export const screenerColumns: ColumnDef<Filing, any>[] = [
  {
    accessorKey: 'name',
    header: 'Case',
    meta: { isFluid: true },
    size: 240,
    cell: ({ row }) => (
      <Link
        to={getFilingPath(row.original)}
        className="font-medium text-blue-7"
      >
        {row.original.name}
      </Link>
    ),
  },
  {
    accessorKey: 'caseNumber',
    header: 'Case number',
    size: 140,
    cell: ({ getValue }) => getValue<string | null>() ?? '—',
  },
  {
    accessorKey: 'filedOn',
    header: 'Filing date',
    size: 130,
    cell: ({ getValue }) => {
      const value = getValue<string | null>()
      return value ? formatDate(value) : '—'
    },
  },
  {
    accessorKey: 'estimatedDistributionCents',
    header: 'Est. proceeds',
    size: 150,
    cell: ({ getValue }) => (
      <span className="font-medium tabular-nums text-blue-7">
        {currencyFromCents(getValue<number | null>())}
      </span>
    ),
  },
  {
    accessorKey: 'estimatedCommissionCents',
    header: 'Est. §326 cap',
    size: 150,
    cell: ({ getValue }) => (
      <span className="tabular-nums">
        {currencyFromCents(getValue<number | null>())}
      </span>
    ),
  },
  {
    accessorKey: 'findingCount',
    header: 'Findings',
    size: 80,
    cell: ({ getValue }) => {
      const count = getValue<number>()
      return count > 0 ? (
        <span className="font-medium">{count}</span>
      ) : (
        <span className="text-muted-foreground">—</span>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 160,
    cell: ({ row }) => <CaseStatusCell filing={row.original} />,
  },
]
